import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  padding: ${spacing.lg}px;
`;
